// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".right-bar[data-v-b110d23c]{height:100%;overflow:auto}", ""]);
// Exports
module.exports = exports;
